import axios from './_defaults/api';

export async function getCategories() {
    try {
        const response = await axios.get("/productscategories");
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function getCategory({categoryId}) {
    try {
        const response = await axios.get(`/productscategories/${categoryId}`);
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}
